import { render, staticRenderFns } from "./AccountPairView.vue?vue&type=template&id=dd48dd8e&"
import script from "./AccountPairView.vue?vue&type=script&lang=js&"
export * from "./AccountPairView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports